import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetch_notifications,
  fetch_unread_count,
  mark_notification_read,
  mark_all_notifications_read,
} from './api';

const LIST_KEY = ['notifications'] as const;
const COUNT_KEY = ['notifications', 'unread-count'] as const;

export function use_notifications(open: boolean) {
  return useQuery({
    queryKey: LIST_KEY,
    queryFn: () => fetch_notifications(false, 30),
    enabled: open,
  });
}

/** Full-page feed (always enabled, deeper list). */
export function use_all_notifications() {
  return useQuery({
    queryKey: [...LIST_KEY, 'all'],
    queryFn: () => fetch_notifications(false, 100),
  });
}

/** Polls the unread badge on a gentle interval. */
export function use_unread_count() {
  return useQuery({
    queryKey: COUNT_KEY,
    queryFn: fetch_unread_count,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}

export function use_notification_actions() {
  const qc = useQueryClient();
  const invalidate = () => {
    qc.invalidateQueries({ queryKey: LIST_KEY });
    qc.invalidateQueries({ queryKey: COUNT_KEY });
  };
  return {
    mark_read: useMutation({ mutationFn: (id: string) => mark_notification_read(id), onSuccess: invalidate }),
    mark_all_read: useMutation({ mutationFn: () => mark_all_notifications_read(), onSuccess: invalidate }),
  };
}
